import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'
import axios from 'axios'
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout
import router from "./router/index";
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n"
import './registerServiceWorker'
import store from "./store";
import { vfmPlugin } from 'vue-final-modal'

Vue.use(vfmPlugin)
Vue.use(BlackDashboard);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VueGoodTablePlugin);
Vue.use(Toast);

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.token}`;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
